import { gql } from '@apollo/client';

export const UPSERT_CONSULTATION = gql`
  mutation upsertConsultation($input: UpsertConsultationInput!) {
    consultation: upsertConsultation(input: $input) {
      id
    }
  }
`;
